import { get } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import withMarketPreOpen from '../../common/market-pre-open/withMarketPreOpen';
import { TYPE_DISABLE } from '../../common/sync-component/Const';
import { withSyncDragCode } from '../../common/sync-drag-code';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../helpers/EventEmitter';
import {
  fetchDataPriceDepth,
  setCondition,
  REDUCER_NAME,
  subscribeRealtimeBidAsk,
  subscribeRealtimeTick,
  subscribeRealtimeDerivative,
} from './reducer';
import IndexSummary from './top-content/index-summary';
import GroupButton from './top-content/group-button';
import IndexInfor from '../common/index-info';
import SwitchTab from './body-content/switch-tab';
import BoxContent from './body-content/box-content';
import InforBoard from './body-content/infor-board';
import {
  getCodeFromQuery,
  getDataFollowKeyByDot,
  getQueryParams,
  removeDragCode,
  syncComponentSelector,
} from './../../helpers/Common';
import Const from './Const';
import ConstCommon from '../../common/Const';
import './index.scss';
import { SearchFilter } from '../../common/search-filter';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import Footer from '../../common/table/Footer';
import ScrollComponent from './../../common/ScrollComponent';
import PreRender from './../../common/PreRender';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../app/commonReducer';
import currentState from './../../helpers/CurrentState';
import AutoReloadOnFocusBlurComponent from '../../../core/loading/AutoReloadOnFocusBlur';

const initialState = {
  relatedInformations: {},
  symbolInformation: {},
  list3Data: null,
  list10Data: null,
};

const LINK_TARGET = 'http://fiingroup.vn/';

class PriceDepth extends AutoReloadOnFocusBlurComponent {
  constructor(props) {
    super(props);
    const { id, setCondition } = props;
    const isPremiumAccount = false;
    this.state = {
      currentTab:
        currentState.get(
          ConstCommon.listComponent.PriceDepth,
          'currentTab',
          id,
        ) || 1,
      isPremiumAccount,
      relatedInformations: {},
      symbolInformation: {},
      list10Data: null,
    };
    const code = getCodeFromQuery(['stock', 'derivative']);
    if (code) {
      setCondition(code, id);
    }
  }

  reload() {
    const { fetchDataPriceDepth, id, listMultiCondition } = this.props;

    const params = {
      code: listMultiCondition[id].condition.code,
    };

    fetchDataPriceDepth(params, id);
  }

  componentDidMount() {
    super.componentDidMount();
    const {
      fetchDataPriceDepth,
      id,
      glContainer,
      listMultiCondition,
    } = this.props;

    const params = {
      code: listMultiCondition[id].condition.code,
    };
    const queryCode = getQueryParams('code');
    if (!queryCode) {
      fetchDataPriceDepth(params, id);
    }

    MessageHub.subscribe(
      ChanelConfig.BidAskChannel,
      this.dispatchDataRealtimeBidAsk,
    );
    MessageHub.subscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
    MessageHub.subscribe(
      ChanelConfig.DerivativeChannel,
      this.dispatchRealtimeDerivative,
    );
    removeDragCode(glContainer);
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    MessageHub.unsubscribe(
      ChanelConfig.BidAskChannel,
      this.dispatchDataRealtimeBidAsk,
    );
    MessageHub.unsubscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
    MessageHub.unsubscribe(
      ChanelConfig.DerivativeChannel,
      this.dispatchRealtimeDerivative,
    );
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, setCondition, id } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      syncType !== data.syncType ||
      data.search.isIndex
    ) {
      return;
    }
    setCondition(data.search, id);
  };

  dispatchRealtimeDerivative = data => {
    const { subscribeRealtimeDerivative, listMultiCondition, id } = this.props;

    const { code } = listMultiCondition[id].condition;
    subscribeRealtimeDerivative(data, code, id);
  };

  dispatchDataRealtimeTick = data => {
    const { subscribeRealtimeTick, listMultiCondition, id } = this.props;

    const { code } = listMultiCondition[id].condition;
    subscribeRealtimeTick(data, code, id);
  };

  dispatchDataRealtimeBidAsk = data => {
    const { subscribeRealtimeBidAsk, listMultiCondition, id } = this.props;

    const { code } = listMultiCondition[id].condition;
    subscribeRealtimeBidAsk(data, code, id);
  };

  componentWillReceiveProps(nextProps) {
    const {
      listMultiComponent,
      listMultiCondition,
      fetchDataPriceDepth,
      id,
    } = this.props;
    // todo: refresh data when change search key
    if (
      Object.keys(listMultiCondition).length &&
      listMultiCondition[id] !== nextProps.listMultiCondition[id]
    ) {
      fetchDataPriceDepth(nextProps.listMultiCondition[id].condition, id);
    }

    // todo: check list component from nextProps to set new data
    if (
      listMultiComponent[id] &&
      listMultiComponent[id].priceDepthData &&
      nextProps.listMultiComponent[id] &&
      nextProps.listMultiComponent[id].priceDepthData
    ) {
      if (Object.keys(nextProps.listMultiComponent[id].priceDepthData).length) {
        const nextPriceDepthData =
          nextProps.listMultiComponent[id].priceDepthData;
        const { isDerivatives } = nextProps.listMultiCondition[id].condition;
        const { extraInfo = null } = nextPriceDepthData;
        const relatedInformations = {
          BID: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.BID,
          ),
          ASK: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.ASK,
          ),
          Fr_Buy_Vol: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.Fr_Buy_Vol,
          ),
          Fr_Sell_Vol: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.Fr_Sell_Vol,
          ),
          VOLUME: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.VOLUME,
          ),
          AVG_PRICE:
            getDataFollowKeyByDot(
              nextPriceDepthData,
              Const.relatedInformations.TOTAL_MATCH_VALUE,
            ) /
            getDataFollowKeyByDot(
              nextPriceDepthData,
              Const.relatedInformations.TOTAL_MATCH_VOLUME,
            ),
          RANKING: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.RANKING,
          ),
          TOTAL_RANK: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.TOTAL_RANK,
          ),
        };

        if (!isDerivatives && extraInfo) {
          relatedInformations.AVG_Vol_1M = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.AVG_Vol_1M,
          );
          relatedInformations.AVG_Vol_10D = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.AVG_Vol_10D,
          );
          relatedInformations.PE = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.PE,
          );
          relatedInformations.ROE = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.ROE,
          );
          relatedInformations.PB = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.PB,
          );
          relatedInformations.FOREIGN_OWNER = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.FOREIGN_OWNER,
          );
          relatedInformations.EPS = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.EPS,
          );
          relatedInformations.BETA = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.BETA,
          );
          relatedInformations.FOREIGN_OWNER = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.FOREIGN_OWNER,
          );
          relatedInformations.MARKET_CAP = getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.relatedInformations.MARKET_CAP,
          );
        }
        const realtimeData = this.getRealtimeData();
        const symbolInfoRealtime =
          realtimeData && realtimeData.symbolInformation
            ? realtimeData.symbolInformation
            : {};
        const marketStatus =
          symbolInfoRealtime.MarketStatus ||
          nextPriceDepthData.price.marketStatus;

        const symbolInformation = {
          marketStatus,
          comGroupCode: nextPriceDepthData.price.comGroupCode,
          MatchPrice: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.MATCH_PRICE,
          ),
          PriceChange: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.PRICE_CHANGE,
          ),
          PercentPriceChange: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.PERCENT_PRICE_CHANGE,
          ),
          OpenPrice: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.OPEN_PRICE,
          ),
          HighestPrice: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.HIGHEST_PRICE,
          ),
          LowestPrice: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.LOWEST_PRICE,
          ),
          Bid: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.BID,
          ),
          Ask: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.ASK,
          ),
          ReferencePrice: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.REFERENCE_PRICE,
          ),
          CeilingPrice: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.CEILING_PRICE,
          ),
          FloorPrice: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.FLOOR_PRICE,
          ),
          TotalMatchVolume: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.TOTAL_MATCH_VOLUME,
          ),
          TradingDate: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.TRADING_DATE,
          ),
          Best1BidVolume: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.Best_1_Bid_Volume,
          ),
          Best1OfferVolume: getDataFollowKeyByDot(
            nextPriceDepthData,
            Const.symbolInformation.Best_1_Offer_Volume,
          ),
        };
        const list10Data = Const.list10Data.map((_, index) => {
          return {
            ...nextPriceDepthData.bidAsk,
            marketStatus,
            comGroupCode: nextPriceDepthData.price.comGroupCode,
            BID:
              getDataFollowKeyByDot(
                nextPriceDepthData,
                Const.list10Data[index].BID,
              ) || 0,
            BID_VOLUME:
              getDataFollowKeyByDot(
                nextPriceDepthData,
                Const.list10Data[index].BID_VOLUME,
              ) || 0,
            ASK:
              getDataFollowKeyByDot(
                nextPriceDepthData,
                Const.list10Data[index].ASK,
              ) || 0,
            ASK_VOLUME:
              getDataFollowKeyByDot(
                nextPriceDepthData,
                Const.list10Data[index].ASK_VOLUME,
              ) || 0,
            TRADING_DATE:
              getDataFollowKeyByDot(
                nextPriceDepthData,
                Const.list10Data[index].TRADING_DATE,
              ) || 0,
          };
        });

        this.setState({
          relatedInformations,
          symbolInformation,
          list10Data,
        });
      } else this.setState({ ...initialState });
    }
  }

  changeTab = currentTab => {
    const { id } = this.props;

    currentState.add(
      ConstCommon.listComponent.PriceDepth,
      'currentTab',
      currentTab,
      id,
    );
    this.setState({ currentTab });
  };

  upgradeAccount = () => {
    const win = window.open(LINK_TARGET, '_blank');
    win.focus();
  };

  getDataIndexSummary = (realTimeData, data) => {
    if (Object.keys(realTimeData).length) {
      return {
        ...data,
        ...realTimeData.symbolInformation,
      };
    }
    return { ...data, TradingDate: null };
  };

  getDataIndexInfor = (realTimeData, data) => {
    if (Object.keys(realTimeData).length) {
      const dataBidAsk =
        Array.isArray(realTimeData.LIST_10_DATA) && realTimeData.LIST_10_DATA[0]
          ? realTimeData.LIST_10_DATA[0]
          : {};

      return {
        ...data,
        ...realTimeData.symbolInformation,
        ...{
          Bid: dataBidAsk.BID,
          Ask: dataBidAsk.ASK,
          Best1BidVolume: dataBidAsk.BID_VOLUME,
          Best1OfferVolume: dataBidAsk.ASK_VOLUME,
        },
      };
    }
    return data;
  };

  getList10Data = (realTimeData, data) => {
    if (Object.keys(realTimeData).length && 'LIST_10_DATA' in realTimeData) {
      return realTimeData.LIST_10_DATA;
    }

    return data;
  };

  getRealtimeData = () => {
    const { id, listMultiComponent } = this.props;
    return id in listMultiComponent &&
      Object.keys(listMultiComponent).length !== 0
      ? listMultiComponent[id].realTimeData
      : {};
  };

  isCoveredWarrant = () => {
    const { coveredWarrantDataByCode, currentSearch } = this.props;

    return !!coveredWarrantDataByCode[currentSearch.code];
  };

  onClickItemSearch = currentSearch => {
    const { id, setCondition, syncType } = this.props;
    setCondition(currentSearch, id);
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: currentSearch,
    });
  };

  render() {
    const {
      listOrganizationByOrganCode,
      listDerivativeByDerivativeCode,
      coveredWarrantDataByCode,
    } = this.props;
    const {
      currentTab,
      isPremiumAccount,
      relatedInformations,
      symbolInformation,
      list10Data,
    } = this.state;
    const { id, listMultiCondition, glContainer } = this.props;
    const realTimeData = this.getRealtimeData();
    const currentSearch =
      id in listMultiCondition
        ? listMultiCondition[id].condition
        : {
            displayCode: ConstCommon.searchBox.organCode,
            code: ConstCommon.searchBox.organCode,
          };
    let isDerivatives = false;
    if (id in listMultiCondition) {
      isDerivatives = listMultiCondition[id].condition.isDerivatives;
    }

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.PriceDepth}>
            <div
              id={`price-depth-export-${id}`}
              className="h-100"
              style={{ overflow: 'auto' }}
            >
              <ScrollComponent>
                <div className="price-depth-wrapper ">
                  <div className="pt-8 px-20">
                    <div className="pd-top-navigation">
                      <div className="pd-top-navigation--left">
                        <div style={{ minWidth: 200, marginRight: 20 }}>
                          <SearchFilter
                            schema={[
                              { key: 'displayCode', className: 'w-20' },
                              {
                                key: 'codeName',
                                className: item =>
                                  `${
                                    item.exchange ? 'w-55' : 'w-80'
                                  } text-truncate`,
                              },
                              {
                                key: 'exchange',
                                className: 'w-25 text-right',
                                render: text => text.toUpperCase(),
                              },
                            ]}
                            listKeyFilter={['displayCode', 'codeName']}
                            getListSearchFromRedux={state => {
                              return [
                                ...state[COMMON_REDUCER_NAME]
                                  .listOrganizationSearch,
                                ...state[COMMON_REDUCER_NAME].listDerivative,
                                ...state[COMMON_REDUCER_NAME]
                                  .listCoveredWarrant,
                              ];
                            }}
                            currentSearch={
                              {
                                ...listOrganizationByOrganCode,
                                ...listDerivativeByDerivativeCode,
                                ...coveredWarrantDataByCode,
                              }[currentSearch.code] || currentSearch
                            }
                            mainKey={'code'}
                            sortKey={'displayCode'}
                            clickItemSearch={this.onClickItemSearch}
                          />
                        </div>
                        <IndexSummary
                          isDerivatives={isDerivatives}
                          keyToCompare={'TradingDate'}
                          data={this.getDataIndexSummary(
                            realTimeData,
                            symbolInformation,
                          )}
                        />
                        <IndexInfor
                          isDerivatives={isDerivatives}
                          data={this.getDataIndexInfor(
                            realTimeData,
                            symbolInformation,
                          )}
                        />
                        <GroupButton />
                      </div>
                    </div>
                    <div className="pd-body">
                      <div className="left-content">
                        <SwitchTab
                          isPremiumAccount={isPremiumAccount}
                          changeTab={this.changeTab}
                          currentTab={this.state.currentTab}
                        />
                        <BoxContent
                          isDerivatives={isDerivatives}
                          currentTab={currentTab}
                          isPremiumAccount={isPremiumAccount}
                          upgradeAccount={this.upgradeAccount}
                          list10Data={this.getList10Data(
                            realTimeData,
                            list10Data,
                          )}
                          symbolInformation={this.getDataIndexInfor(
                            realTimeData,
                            symbolInformation,
                          )}
                        />
                      </div>
                      {this.isCoveredWarrant() || (
                        <div className="right-content">
                          <InforBoard
                            relatedInformations={relatedInformations}
                            isDerivatives={isDerivatives}
                            symbolInformation={this.getDataIndexInfor(
                              realTimeData,
                              symbolInformation,
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="pl-20 pr-20">
                    {!isDerivatives && <Footer />}
                  </div>
                </div>
              </ScrollComponent>
            </div>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapStateToProps = (state, { id }) => {
  return {
    priceDepthData: state[REDUCER_NAME].priceDepthData,
    i18n: state.i18n,
    listMultiComponent: state[REDUCER_NAME].listMultiComponent,
    listMultiCondition: state[REDUCER_NAME].listMultiCondition,
    currentSearch: state[REDUCER_NAME].listMultiCondition[id].condition,
    userInfo: state.userInfo,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    listDerivativeByDerivativeCode:
      state[COMMON_REDUCER_NAME].listDerivativeByDerivativeCode,
    coveredWarrantDataByCode:
      state[COMMON_REDUCER_NAME].coveredWarrantDataByCode,
    syncType: syncComponentSelector(
      state,
      ConstCommon.listComponent.PriceDepth,
      id,
    ),
  };
};

const mapDispatchToProps = {
  fetchDataPriceDepth,
  setCondition,
  subscribeRealtimeBidAsk,
  subscribeRealtimeTick,
  subscribeRealtimeDerivative,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withMarketPreOpen(),
  withSyncDragCode,
)(PriceDepth);
